import {HIDE_TOAST, SHOW_TOAST} from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  open: false,
  type: '',
  message: '',
};

const toastsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST:
      return updateObject(state, {
        open: true,
        type: action.toastType,
        message: action.message,
      });
    case HIDE_TOAST:
      return updateObject(state, {open: false, type: '', message: ''});
    default:
      return state;
  }
};

export default toastsReducer;
